<template>
  <div class="prompt">
    <img :src="require('@/assets/img/prompt.png')">
  </div>
</template>

<script>
export default {
  name: "Prompt"
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/com.scss";
.prompt {
  @include wh(100%, 100%);
  overflow: hidden;
  font-size: 1rem;
  position: relative;
  background: white;
  img {
    @include LTRBcenter;
    @include wh(50%);
    transform: translate(-50%, -70%);
  }
}
</style>


